import {EMPTY_CURRENT_REQUEST} from "../../../enums/Request/currentRequestControls.types";

export const emptyCurrentRequest = (classTemplate) => {
    return {
        type: EMPTY_CURRENT_REQUEST,
        payload: classTemplate,
    };
};
